import { useOktaAuth } from '@okta/okta-react';
import { useCallback } from 'react';

import { logout } from 'contexts/account/api/me';
import { clearDatadogRumUser } from 'utils/datadog-rum';
import { clearState } from 'utils/storage';
import { usePondsState } from 'views/production-systems/context/ponds-context';

export function useLogout() {
  const { oktaAuth } = useOktaAuth();
  const { disconnectSignalR } = usePondsState();

  return useCallback(
    async (onComplete?: () => void) => {
      await disconnectSignalR();

      // The API call signs the request with the current token, so it runs before the token is revoked.
      // It also deny-lists the token, so a separate revoke call would only return 403.
      await logout().catch((error) => console.log(error));

      // A refresh token outlives the Okta session, so it has to be revoked or it can still mint access tokens
      await oktaAuth.revokeRefreshToken().catch((error) => console.log(error));
      await oktaAuth.revokeAccessToken().catch((error) => console.log(error));
      oktaAuth.tokenManager.clear();

      clearDatadogRumUser();
      clearState({ key: 'companyId' });
      clearState({ key: 'userId' });
      clearState({ key: 'okta-token-storage' });
      clearState({ key: 'okta-transaction-storage' });
      clearState({ storage: 'local', key: 'okta-shared-transaction-storage' });

      onComplete?.();
    },
    [disconnectSignalR, oktaAuth]
  );
}
